import Loader from "@/atoms-react/loader/Loader.react";
import { Base } from "@/atoms-react/text/Text.react";
import { EmptyPageCactusAnimation } from "@/components/animations/empty-cactus/index.react";
import { companyAdminListType } from "@/features/admin/types";
import { Routes } from "@/features/router";
import { MenuItemWithIcon } from "@/molecules/menu-item-with-icon/menu-item-with-icon";
import { Pagination } from "@/views/dashboard/components/transactions/pagination";
import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import { ShieldCheckIcon } from "@heroicons/react/20/solid";
import { BuildingOffice2Icon, EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";

type listAdminProps = {
  listcompaniesResponse?: { companyList: companyAdminListType[]; hasMore: boolean; count: number };
  isLoading: boolean;
  page: number;
  limit: number;
  handlePage: (page: number) => void;
  handleLimit: (limit: number) => void;
  isPlaceholderData: boolean;
};
const ListCompanies = ({
  listcompaniesResponse,
  isLoading = false,
  handlePage,
  page = 1,
  handleLimit,
  limit
}: listAdminProps) => {
  const { t } = useTranslation(["pass"]);
  const navigate = useNavigate();

  const getShield = (level: number) => {
    switch (level) {
      case 0:
        return (
          <div
            className="flex flex-row rounded-sm px-3 py-1"
            style={{ backgroundColor: "#D11E1F" }}
          >
            <ShieldCheckIcon className="h-6 w-8 text-white" />
            <Base className="text-white">1</Base>
          </div>
        );
      case 1:
        return (
          <div
            className="flex flex-row rounded-sm px-3 py-1"
            style={{ backgroundColor: "#D11E1F" }}
          >
            <ShieldCheckIcon className="h-6 w-8 text-white" />
            <Base className="text-white">1</Base>
          </div>
        );
      case 2:
        return (
          <div
            className="flex flex-row rounded-sm px-3 py-1"
            style={{ backgroundColor: "#1D98DF" }}
          >
            <ShieldCheckIcon className="h-6 w-8 text-white" />
            <Base className="text-white">2</Base>
          </div>
        );
      case 3:
        return (
          <div
            className="flex flex-row rounded-sm px-3 py-1"
            style={{ backgroundColor: "#82C805" }}
          >
            <ShieldCheckIcon className="h-6 w-8 text-white" />
            <Base className="text-white">3</Base>
          </div>
        );
      case 4:
        return (
          <div
            className="flex flex-row rounded-sm px-3 py-1"
            style={{ backgroundColor: "#652E10" }}
          >
            <ShieldCheckIcon className="h-6 w-8 text-white" />
            <Base className="text-white">4</Base>
          </div>
        );
      case 5:
        return (
          <div
            className="flex flex-row rounded-sm px-3 py-1"
            style={{ backgroundColor: "#B7B7B7" }}
          >
            <ShieldCheckIcon className="h-6 w-8 text-white" />
            <Base className="text-white">5</Base>
          </div>
        );
      case 6:
        return (
          <div
            className="flex flex-row rounded-sm px-3 py-1"
            style={{ backgroundColor: "#D09A31" }}
          >
            <ShieldCheckIcon className="h-6 w-8 text-white" />
            <Base className="text-white">6</Base>
          </div>
        );

      default:
        break;
    }
  };
  const handleStatus = (status: number) => {
    switch (status) {
      case 0:
        return (
          <div className="w-1/2 rounded-sm bg-[#EEEEEE] dark:bg-slate-900">
            <Base className="rounded-sm border border-[#5A5A58] p-2 text-center font-semibold text-sm">
              Inactif
            </Base>
          </div>
        );
      case 4:
        return (
          <div className="w-1/2 rounded-sm border-red-500 bg-red-100 dark:bg-slate-900">
            <Base className="rounded-sm border border-red-500 p-2 text-center font-semibold text-red-500 text-sm">
              Suspendu
            </Base>
          </div>
        );
      case 1:
        return (
          <div className="w-1/2 rounded-sm border-success-500 bg-success-100 dark:bg-slate-900">
            <Base className="rounded-sm border border-success-500 p-2 text-center font-semibold text-red-500 text-sm">
              Approuvé{" "}
            </Base>
          </div>
        );
        break;
      case 3:
        return (
          <div className="w-1/2 rounded-sm border-gray-500 bg-gray-100 dark:bg-slate-900">
            <Base className="rounded-sm border border-gray-500 p-2 text-center font-semibold text-gray-500 text-sm">
              {status}
            </Base>
          </div>
        );
        break;

      default:
        break;
    }
  };
  return (
    <div className="overflow-x-auto overflow-y-hidden rounded-sm border-0 border-slate-50 lg:overflow-x-hidden lg:p-0">
      <div className="flex flex-col">
        <div className="flex min-w-sm flex-row justify-between px-4 lg:min-w-0">
          <div className="w-full min-w-[250px] basis-2/9">
            <Base className="text-semibold text-sm lg:text-base">{t("business.title")}</Base>
          </div>
          <div className="w-full min-w-[150px] basis-2/9">
            <Base className="text-semibold text-sm lg:text-base">
              {t("business.new.input.rcs_code")}
            </Base>
          </div>
          <div className="w-full min-w-[100px] basis-1/9">
            <Base className="text-semibold text-sm lg:text-base"> OlkyPass </Base>
          </div>
          <div className="w-full min-w-[100px] basis-1/9">
            <Base className="text-semibold text-sm lg:text-base">Status </Base>
          </div>

          <div className="w-full min-w-[100px] basis-1/9">
            <Base className="text-semibold text-sm lg:text-base">
              {t("business_links.add_link.table_header.1")}
            </Base>
          </div>
          <div className="w-full min-w-[100px] basis-1/9">
            <Base className="text-semibold text-sm lg:text-base">
              {t("business_links.add_link.table_header.1.5")}
            </Base>
          </div>

          <div className="flex w-full min-w-[100px] basis-1/9 basis-1/9 flex-col justify-start">
            <div className="flex lg:justify-end">
              <Base className="text-semibold text-sm lg:text-base">Action </Base>
            </div>
          </div>
        </div>

        <div>
          <ul className="mt-2 min-w-sm rounded-sm rounded-sm border-slate-50 lg:min-w-0 lg:border-2 dark:border-slate-700">
            {isLoading ? (
              <div className="flex h-[400px] justify-center">
                <div className="flex h-[400px] flex-col items-center justify-center">
                  <Loader />
                </div>
              </div>
            ) : !listcompaniesResponse?.companyList ||
              listcompaniesResponse?.companyList.length === 0 ? (
              <div className="flex h-[400px] justify-center">
                <div className="flex h-[400px] flex-col items-center justify-center">
                  <EmptyPageCactusAnimation />
                  <Base className="mt-4 mb-2"> {t("business.label.empty")}</Base>
                </div>
              </div>
            ) : (
              listcompaniesResponse?.companyList?.length > 0 &&
              listcompaniesResponse?.companyList?.map((company, index) => (
                <li className={twMerge(index != 0 && "border-t-2", "w-max lg:w-full")} key={index}>
                  <div className="flex h-[100px] min-w-sm flex-row justify-between px-3 lg:min-w-0">
                    <div className="flex w-full min-w-[250px] basis-2/9 flex-col justify-center">
                      <div className="flex flex-row">
                        <BuildingOffice2Icon className="h-5 w-5 dark:text-white" />
                        <Base className="ml-2 text-sm" data-tooltip={company.legal_name}>
                          {" "}
                          {company.legal_name}
                        </Base>
                      </div>
                    </div>
                    <div className="flex w-full min-w-[150px] basis-2/9 flex-col justify-center">
                      <Base className="text-sm"> {company.rcs}</Base>
                    </div>
                    <div className="flex w-full min-w-[100px] basis-1/9 flex-col justify-center">
                      <div className="flex flex-row">{getShield(company.olkypass_lvl)}</div>
                    </div>
                    <div className="flex w-full min-w-[100px] basis-1/9 flex-col justify-center">
                      <Base className="text-sm">{handleStatus(company.olkypass_status)}</Base>
                    </div>
                    <div className="flex w-full min-w-[100px] basis-1/9 flex-col justify-center">
                      <Base className="text-sm">{company.agent_count}</Base>
                    </div>
                    <div className="flex w-full min-w-[100px] basis-1/9 flex-col justify-center">
                      <Base className="text-sm">{company.bo_count}</Base>
                    </div>

                    <div className="flex w-full min-w-[100px] basis-1/9 flex-col justify-center">
                      <div className="flex lg:justify-end">
                        <Menu as="div">
                          <MenuButton
                            data-cy={`menu-button-${company.legal_name}`}
                            className="rounded-sm border-2 border-slate bg-white/10 p-2 text-sm hover:border-slate-100 hover:bg-white/20 dark:border-slate-700 dark:border-b-2 dark:bg-slate-950"
                          >
                            <EllipsisVerticalIcon
                              data-cy={`menu-button-${company.legal_name}`}
                              aria-hidden="true"
                              className={twMerge("size-5 text-primary")}
                            />
                          </MenuButton>

                          <MenuItems className="z absolute right-2 mt-1 rounded-sm border bg-white py-1">
                            <MenuItemWithIcon
                              title={t("admin_page.table.menu_button.navigate_links")}
                              icon={"Pencil"}
                              showBorderBottom
                              data-cy={`related-person-${company.legal_name}`}
                              action={() =>
                                navigate(`${Routes.companies}/${company.uuidLegal}/related_person`)
                              }
                            />
                            <MenuItemWithIcon
                              title={t("admin_page.table.menu_button.navigate_olkypass_pro")}
                              showBorderBottom={false}
                              icon={"Pencil"}
                              data-cy={`level-${company.legal_name}`}
                              action={() => navigate(`${Routes.level}/${company.uuidLegal}`)}
                            />
                          </MenuItems>
                        </Menu>
                      </div>
                    </div>
                  </div>
                </li>
              ))
            )}
          </ul>
        </div>
        {!isLoading &&
          listcompaniesResponse?.companyList &&
          listcompaniesResponse.companyList?.length > 0 && (
            <Pagination
              currentPage={page}
              handlePrev={() => handlePage(Math.max(page - 1, 0))}
              setLimit={(value: number) => handleLimit(value)}
              limit={limit}
              count={listcompaniesResponse.count ?? 0}
              totalPages={
                listcompaniesResponse?.count ? Math.ceil(listcompaniesResponse?.count / limit) : 1
              }
              onClick={(page: number) => {
                handlePage(page);
              }}
              handleNext={() => {
                const maxPage = listcompaniesResponse?.count
                  ? Math.ceil(listcompaniesResponse?.count / limit)
                  : 1;
                if (page < maxPage) {
                  handlePage(page + 1);
                }
              }}
            />
          )}
      </div>
    </div>
  );
};
export default ListCompanies;
